exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assignment-selector{padding:0 1.75em}.assignment-selector .search-container{margin-bottom:.55rem}.assignment-selector .tabs .selector{margin-bottom:0}.assignment-selector .assignment{display:flex;align-items:center;cursor:pointer;padding:1.25rem;margin-left:-1.25rem;margin-right:-1.25rem}.assignment-selector .assignment:hover{background-color:#f5f5f5}.assignment-selector .assignment .card-meta{margin:0;margin-left:5px}.badge-primary{background-color:var(--color--blue);text-align:center;color:#fff;font-size:var(--size-12);width:auto;border-radius:4px;padding:.24rem .65rem;display:inline-flex}", ""]);

// exports
